import { render, staticRenderFns } from "./assist-tel-team-collection.vue?vue&type=template&id=7c408cee"
import script from "./assist-tel-team-collection.vue?vue&type=script&lang=ts"
export * from "./assist-tel-team-collection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports